export default "__VITE_ASSET__DC39X6fY__"